import { ISelect } from "@shared/components";
import { IShop } from "./shop.interface";

export interface IProduct {
    id: number;
    shop_id: number;
    shop_name: string;
    shop?:any
    avatar_url: string[];
    avatar_url_preview: string[];
    image_path?: any,
    image_path_preview?: any,
    size: ISelect[] | null;
    color: ISelect[] | null;
    category_id: number;
    name: string;
    link: string;
    comment_card: any,
    desc: string;
    price: any;
    discount: any;
    discount_percent: any;
    time_discount_end: any;
    isAddedToCard: any;
    countdownConfigHour: any;
    is_only_time: any;
    is_from_checkbox: any;
    active_counter: any;
}

export interface ILoadProducts {
    current_page: number;
    total: number;
    data: ILoadProduct[];
}

export interface ILoadProduct {
    id: number;
    shop_id: number;
    operator_id: number;
    category_id: number;
    active: boolean;
    shop: IShop;
    category: ICategory;
    created_at: string;
    comment_card: any,
    description: string;
    image_path: string[];
    image_preview_path: string[];
    avatar_url_preview: string[];
    color: string[] | null;
    size: string[] | null;
    link: string;
    updated_at: string;
    price: any;
    discount: any;
    discount_percent: any;
    time_discount_end: any;
    isAddedToCard: any;
    countdownConfigHour: any;
    is_only_time: any;
    is_from_checkbox: any,
    active_counter: any;
}

export interface IProductsOffered {
    id: number;
    shop_id: number;
    operator_id: number;
    category_id: number;
    active: boolean;
    category: ICategory;
    created_at: string;
    description: string;
    image_path: string[];
    color: string[] | null;
    size: string[] | null;
    link: string;
    shop: IShop;
    updated_at: string;
}

export interface ICategory {
    description: string;
    id: number;
    name: string;
    created_at: null;
    updated_at: null;
}

export interface ILoadAdminProduct {
    current_page: number;
    total: number;
    data: IAdminProduct[];
}

export interface IAdminProduct {
    id:number;
    active: boolean;
    avatar_url: string[];
    size: any;
    name: string;
    color: any;
    comment_card: any,
    desc: string;
    category: any;
    shop: any;
    link: string;
    price: any;
    discount: any;
    tags: any[];
    subtags: any[];
    is_from_checkbox: any,
    delivery_free?: any,
    delivery_deadline?: any,
    fast_delivery?: any,
    discount_percent: any;
    time_discount_end: any;
    countdownConfigHour: any;
    is_only_time: any;
    active_counter: any;
    edit_mode: any;
}